module.exports = function getResource(label, vars = []) {
    let resources = { freeShipping: 'Expédition gratuite' };
    return resources[label];
};
